var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgReplaceIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#FFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.279 12.53a.45.45 0 01-.444-.455C.835 6.051 5.615 1.15 11.49 1.15c4.385 0 8.27 2.697 9.897 6.871a.46.46 0 01-.247.592.44.44 0 01-.577-.254C19.07 4.533 15.509 2.06 11.49 2.06c-5.386 0-9.767 4.493-9.767 10.015a.45.45 0 01-.444.455M11.489 23c-4.352 0-8.226-2.67-9.87-6.802a.46.46 0 01.244-.594.44.44 0 01.579.25C3.948 19.642 7.5 22.09 11.49 22.09c5.385 0 9.767-4.493 9.767-10.015a.45.45 0 01.444-.455.45.45 0 01.444.455C22.145 18.099 17.365 23 11.49 23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.111 9.112a.433.433 0 01-.18-.04l-3.245-1.481a.46.46 0 01-.224-.601c.1-.23.361-.335.586-.23l2.838 1.296 1.265-2.911a.438.438 0 01.585-.231.46.46 0 01.225.6l-1.444 3.327a.447.447 0 01-.406.27M.443 19.257a.423.423 0 01-.18-.04.459.459 0 01-.224-.6l1.444-3.328a.438.438 0 01.586-.23l3.245 1.48a.46.46 0 01.225.602.437.437 0 01-.586.23l-2.84-1.295-1.264 2.91a.442.442 0 01-.406.27"
  }))));
}

export default SvgReplaceIcon;